<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card>
          <el-collapse v-model="activeName" @change="handleCollapse">
            <el-collapse-item
              :title="titleFilter"
              name="filter"
              class="filter-component"
            >
              <filter-component
                :filterOfFarms="false"
                :filterOfLots="false"
                :showDivision="true"
                :showHour="true"
                @filter="handleFilter"
                @showHideLoading="showHideLoading"
              >
                <template slot="prev">
                  <div class="col-12 col-sm-6 col-md-6 pt-3">
                    <label for="">{{ $t('devices.stations_normal') }}: </label>
                    <br />
                    <el-select
                      @change="
                        selectAllFromSelect('stationsSel', stations);
                        reportData = [];
                      "
                      clearable
                      collapse-tags
                      style="width: 100%"
                      multiple
                      filterable
                      class="select-primary custom-width-select shadow-sm required-stations"
                      v-model="stationsSel"
                      :placeholder="`${$t('common_words.select2')}...`"
                      @clear="
                        reportData = [];
                        sensorsSel = [];
                      "
                    >
                      <el-option
                        class="select-primary selected-all"
                        v-for="item in stations"
                        :key="`${item.id}-${item.name}`"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 pt-3">
                    <label for="">{{ $t('devices.sensors') }}: </label>
                    <br />
                    <el-select
                      @change="
                        selectAllFromSelect('sensorsSel', handleSensor);
                        reportData = [];
                      "
                      clearable
                      collapse-tags
                      style="width: 100%"
                      multiple
                      filterable
                      class="select-primary custom-width-select shadow-sm required-sensors"
                      v-model="sensorsSel"
                      :placeholder="`${$t('common_words.select2')}...`"
                      @clear="reportData = []"
                    >
                      <el-option
                        class="select-primary selected-all"
                        v-for="item in handleSensor"
                        :key="`${item.id}-${item.two_name}`"
                        :label="item.two_name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </template>
              </filter-component>
            </el-collapse-item>
          </el-collapse>
        </card>
        <card v-if="validateLengthReportData">
          <el-container>
            <aside-list
              @clickItem="loadDataStation"
              :label="$t('devices.stations_normal')"
              :list="stationsFiltered"
              v-if="stationsFiltered.length > 1"
            />
            <el-container>
              <el-main>
                <div class="row mb-3 justify-content-center">
                  <div class="col-3" v-if="validateETOData && showAvgEto">
                    <kpi :label="$t('irrigation.eto_avg')" :value="getAvgEto">
                      <template slot="unit">
                        <small style="font-size: 15px"> mm</small>
                      </template>
                    </kpi>
                  </div>
                  <div class="col-3" v-if="validateETOData && showSumRain">
                    <kpi
                      :label="$t('irrigation.accumulated_rain')"
                      :value="getSumRain"
                    >
                      <template slot="unit">
                        <small style="font-size: 15px"> mm</small>
                      </template>
                    </kpi>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <card
                      class="custom-shadow-card-header"
                      v-if="validateETOData"
                    >
                      <div class="row">
                        <chart-header-options
                          :autoChange="false"
                          :chartData="chartOptions[2]"
                          :index="2"
                          @handleLoadChartOptions="handleLoadChartOptions"
                        />
                        <div
                          v-if="Object.keys(chartOptions[2]).length > 0"
                          class="col-12"
                        >
                          <highcharts :options="chartOptions[2]"></highcharts>
                        </div>
                      </div>
                    </card>
                    <card
                      class="custom-shadow-card-header"
                      v-if="
                        dataByStation.eagChart &&
                        dataByStation.eagChart.values.length > 0
                      "
                    >
                      <div class="row">
                        <chart-header-options
                          :autoChange="false"
                          :chartData="chartOptions[0]"
                          :index="0"
                          @handleLoadChartOptions="handleLoadChartOptions"
                        >
                          <template
                            slot="append"
                            v-if="editWiltingSaturationPoints()"
                          >
                            <div
                              class="col-1"
                              style="width: 25px; flex: initial !important"
                              :v-tooltip.bottom="
                                $t('irrigation.wilting_and_saturation_point')
                              "
                            >
                              <point-and-saturation-form
                                :station="dataByStation.stationId"
                                :wilting="dataByStation.wiltingPoint"
                                :saturation="dataByStation.saturationPoint"
                                @getDataReport="getDataReport"
                                @updateBackground="updateBackground"
                                @handleChangeSwitch="handleChangeSwitch"
                              />
                            </div>
                            <div class="col-1">
                              <el-input-number
                                ref="valueFromLine"
                                :disabled="!enableFromLine"
                                size="mini"
                                v-model="valueFromLine"
                                controls-position="right"
                                @change="(e) => handleChange(e, 0)"
                                :min="0"
                                :max="900"
                                :step="5"
                                style="width: 90px"
                                :v-tooltip.bottom="
                                  $t('common_words.objective_percent')
                                "
                              ></el-input-number>
                            </div>
                            <div
                              class="col-1 ml-2 pl-4"
                              :v-tooltip.bottom="
                                $t(
                                  'irrigation.wilting_and_saturation_point_hide'
                                )
                              "
                            >
                              <l-switch
                                class="mt-1"
                                v-model="showBackground"
                                on-text="ON"
                                off-text="OFF"
                                @onChange="handleChangeSwitch"
                              >
                              </l-switch>
                            </div>
                          </template>
                        </chart-header-options>
                        <div
                          class="col-12"
                          v-if="Object.keys(chartOptions[0]).length > 0"
                        >
                          <highcharts :options="chartOptions[0]"></highcharts>
                        </div>
                      </div>
                    </card>
                    <card
                      class="custom-shadow-card-header"
                      v-if="
                        dataByStation.soilChart &&
                        dataByStation.soilChart.values.length > 0
                      "
                    >
                      <div class="row">
                        <chart-header-options
                          :autoChange="false"
                          :chartData="chartOptions[1]"
                          :index="1"
                          @handleLoadChartOptions="handleLoadChartOptions"
                        />
                        <div
                          v-if="Object.keys(chartOptions[1]).length > 0"
                          class="col-12"
                        >
                          <highcharts :options="chartOptions[1]"></highcharts>
                        </div>
                      </div>
                    </card>
                    <card
                      class="custom-shadow-card-header"
                      v-if="
                        dataByStation.table && dataByStation.table.length > 0
                      "
                    >
                      <card-header
                        :propPagination="pagination"
                        @searchedQuery="searchedQuery"
                        class="mr-3 mt-4"
                      ></card-header>
                      <master-table
                        :infoTable="queriedData"
                        :columns="tableColumns"
                      />
                      <card-footer
                        ref="cardfooter"
                        :propPagination="pagination"
                      />
                      <export-tables
                        :pdf="{
                          filename: `${$t('irrigation.irrigation')}.pdf`,
                          route: 'irrigation/irrigation/eag/pdf',
                          paramMethod: 'POST',
                          plusData: { ...getDataToExport },
                        }"
                        :xls="{
                          filename: `${$t('irrigation.irrigation')}.xlsx`,
                          route: 'irrigation/irrigation/eag/excel',
                          paramMethod: 'POST',
                          plusData: { ...getDataToExport },
                        }"
                      />
                      <br />
                    </card>
                  </div>
                </div>
              </el-main>
            </el-container>
          </el-container>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Chart } from 'highcharts-vue';
import { Pagination as LPagination } from 'src/components/index';
import { Switch as LSwitch } from 'src/components';
import AbbreviatedTextTooltip from 'src/components/Texts/AbbreviatedTextTooltip.vue';
import AsideList from 'src/components/Layouts/AsideList.vue';
import ChartHeaderOptions from 'src/components/Chart/ChartHeaderOptions.vue';
import configTable from './IrrigationTable';
import exportingInit from 'highcharts/modules/exporting';
import Filter from 'src/components/Filter/Filters.vue';
import Formatter from 'src/class/Formatter';
import Fuse from 'fuse.js';
import Highcharts from 'highcharts';
import i18n from 'src/i18n';
import Kpi from 'src/views/Layouts/Kpi.vue';
import MixinCharts from 'src/util/mixinCharts';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import PointAndSaturationForm from './PointAndSaturationForm.vue';
import SweetAlert from 'src/class/Alerts';

exportingInit(Highcharts);

export default {
  components: {
    [AbbreviatedTextTooltip.name]: AbbreviatedTextTooltip,
    [AsideList.name]: AsideList,
    [ChartHeaderOptions.name]: ChartHeaderOptions,
    [Filter.name]: Filter,
    [Kpi.name]: Kpi,
    [PointAndSaturationForm.name]: PointAndSaturationForm,
    highcharts: Chart,
    LPagination,
    LSwitch,
    PointAndSaturationForm,
  },

  data() {
    return {
      activeName: 'filter',
      chartOptions: [],
      dataByStation: [],
      dataFilter: {
        datef: moment().format('YYYY-MM-DD'),
        datei: moment().subtract(1, 'year').format('YYYY-MM-DD'),
      },
      enableFromLine: true,
      pagination: {},
      reportData: [],
      sensors: [],
      sensorsSel: [],
      stations: [],
      stationsSel: [],
      valueCollapse: null,
      tableColumns: [],
      valueFromLine: 0,
      showBackground: true,
      tmpPlotBands: {},
    };
  },

  mixins: [MixinCharts, MixinForm, MixinMasters, MixinMenu, MixinPermissions],

  computed: {
    validateLengthReportData() {
      return Object.values(this.reportData).length > 0;
    },
    getDataToExport() {
      const response = { ...this.dataFilter };
      delete response.route;

      return response;
    },
    stationsFiltered() {
      try {
        const stations = Object.keys(this.reportData).map((key) => Number(key));
        return this.stations.filter((station) => {
          return stations.includes(station.id);
        });
      } catch (error) {
        return [];
      }
    },
    handleSensor() {
      try {
        const response = this.sensors.filter((sensor) => {
          if (sensor.stations)
            return sensor.stations.some((station) =>
              this.stationsSel.includes(station)
            );
        });

        return this.concatAll(response, 'two_name');
      } catch (error) {
        return this.concatAll([]);
      }
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    validateETOData() {
      try {
        return (
          this.dataByStation.etoAndPrecipitationChart &&
          this.dataByStation.etoAndPrecipitationChart.values.length > 0
        );
      } catch (error) {
        return false;
      }
    },
    showAvgEto() {
      return this.dataByStation.etoAndPrecipitationChart.values.some(
        (value) => value.sensor === 'ETO'
      );
    },
    showSumRain() {
      return this.dataByStation.etoAndPrecipitationChart.values.some(
        (value) => value.sensor === 'rain'
      );
    },
    getAvgEto() {
      try {
        const data = this.dataByStation.etoAndPrecipitationChart.values.find(
          (value) => value.sensor === 'ETO'
        ).data;
        const sum = data.reduce((acc, data) => {
          if (data) return acc + data;
        }, 0);

        return Formatter.formatNumber(Number(sum / data.length));
      } catch (error) {
        return 0;
      }
    },
    getSumRain() {
      try {
        const sum = this.dataByStation.etoAndPrecipitationChart.values
          .find((value) => value.sensor === 'rain')
          .data.filter((value) => value !== null)
          .reduce((acc, data) => {
            if (data) return acc + data;
          }, 0);

        return Formatter.formatNumber(Number(sum));
      } catch (error) {
        return 0;
      }
    },
  },

  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.stations = this.concatAll(this.stations.splice(1));
    },

    updateBackground(value) {
      this.showBackground = value;
    },

    handleChangeSwitch() {
      if (!this.showBackground) {
        this.tmpPlotBands = this.dataByStation.eagChart.plotBands;
        const chartData = { ...this.chartOptions[0] };
        this.$set(this.chartOptions, 0, {});

        setTimeout(() => {
          if (Array.isArray(chartData.yAxis)) {
            chartData.yAxis.forEach((axis) => {
              if (axis.gridLineWidth) delete axis.gridLineWidth;
              if (axis.plotBands) delete axis.plotBands;
            });
          } else {
            if (chartData.yAxis.gridLineWidth)
              delete chartData.yAxis.gridLineWidth;
            if (chartData.yAxis.plotBands) delete chartData.yAxis.plotBands;
          }

          this.$set(this.chartOptions, 0, chartData);
        }, 0.1);
      } else {
        if (this.tmpPlotBands) {
          let yAxis = {};
          if (Array.isArray(this.chartOptions[0].yAxis)) {
            yAxis = [...this.chartOptions[0].yAxis];
            yAxis[0] = { ...yAxis[0], ...this.tmpPlotBands };
          } else {
            yAxis = { ...this.chartOptions[0].yAxis, ...this.tmpPlotBands };
          }

          const chartData = { ...this.chartOptions[0] };
          this.$set(chartData, 'yAxis', yAxis);
          this.$set(this.chartOptions, 0, chartData);
        }
      }
    },

    handleLoadChartOptions(data) {
      this.$set(this.chartOptions, data.index, data.chartData);
    },

    handleChange(value, index) {
      this.enableFromLine = false;
      try {
        this.chartOptions[index].yAxis.plotLines[0].value = value;
      } catch (error) {
        //
      }

      let data = {};
      data.route = 'devices/station/pointline';
      data.plot_line = value;
      data.station = this.dataByStation.stationId;

      Axios.postMasters(data)
        .then(() => {
          // this.getDataReport(2);
          this.enableFromLine = true;
        })
        .catch((error) => {
          console.log(error);
          this.enableFromLine = true;
          this.showHideLoading();
        });
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleFilter(data) {
      this.reportData = [];
      this.dataFilter = { ...data };
      if (this.stationsSel.length === 0)
        this.validationInputsRequired('stations');
      else if (this.sensorsSel.length === 0)
        this.validationInputsRequired('sensors');
      else this.getDataReport();
    },

    loadDataStation(data) {
      const { id, type } = data;

      if (type && type === 'aside' && !this.reportData[id]) {
        SweetAlert.warning(i18n.t('common_words.unavailable_data'));
        this.dataByStation = [];
      }

      if (this.reportData[id]) {
        this.dataByStation = { ...this.reportData[id] };
        this.dataByStation.stationId = id;

        this.tableColumns = configTable().Table.tableColumns.concat(
          this.dataByStation.columns
        );
        this.tableData = this.dataByStation.table;

        try {
          this.valueFromLine = this.dataByStation.eagChart.plotLines[0]
            ? this.dataByStation.eagChart.plotLines[0].value
            : null;
        } catch (error) {
          this.valueFromLine = 0;
        }

        this.$set(this.chartOptions, 0, {});
        this.$set(this.chartOptions, 1, {});
        this.$set(this.chartOptions, 2, {});

        this.showHideLoading(true);
        setTimeout(() => {
          this.$set(
            this.chartOptions,
            0,
            this.lines(
              this.dataByStation.eagChart,
              false,
              620,
              this.showBackground
            )
          );
          this.$set(
            this.chartOptions,
            1,
            this.lines(this.dataByStation.soilChart, false, 620)
          );
          this.$set(
            this.chartOptions,
            2,
            this.columns(
              this.dataByStation.etoAndPrecipitationChart,
              false,
              null,
              620
            )
          );
          this.showHideLoading();
        }, 0.1);

        this.fuseSearch = new Fuse(this.tableData, {
          useExtendedSearch: true,
          threshold: 0.3,
          keys: this.tableColumns.map((prop) => {
            return prop.prop;
          }),
        });

        setTimeout(() => {
          this.updateDataPagination(
            'cardfooter',
            [this.from, this.to, this.total],
            5
          );
        }, 10);
      }
    },

    getDataReport(loading = 1) {
      this.pagination.perPage = 10;
      this.pagination.currentPage = 1;
      this.searchQuery = '';

      if (Number(loading) === 1) {
        this.reportData = [];
        this.dataByStation = [];
      }

      if ([1, 3].includes(Number(loading))) this.showHideLoading(true);

      let data = this.dataFilter;
      data.route = 'irrigation/irrigation/eag';
      data.stations = this.stationsSel;
      data.sensors = this.sensorsSel;

      Axios.postMasters(data)
        .then((response) => {
          const { data: dataResponse } = response;
          const { data } = dataResponse;
          Object.entries(data).forEach((item) => {
            if (item[1].table.length > 0) {
              const resp = {};
              resp[item[0]] = item[1];
              this.reportData = { ...this.reportData, ...resp };
            }
          });

          if (sessionStorage.getItem('changePoints')) {
            this.loadDataStation({
              id: Number(sessionStorage.getItem('changePoints')),
              type: 'auto',
            });
            sessionStorage.removeItem('changePoints');
          } else {
            if (Object.keys(this.reportData).length > 0) {
              if (this.stationsFiltered.length > 1) {
                setTimeout(() => {
                  const aside = document.getElementsByClassName(
                    'el-menu-item custom-el-menu-item-cal'
                  )[0];
                  aside.click();
                }, 100);
              } else {
                this.loadDataStation({
                  id: Number(Object.keys(this.reportData)[0]),
                  type: 'auto',
                });
              }
            } else {
              SweetAlert.warning(i18n.t('common_words.unavailable_data'));
              this.reportData = [];
              this.dataByStation = [];
            }
          }

          if ([1, 3].includes(Number(loading))) this.showHideLoading();
        })
        .catch((error) => {
          if ([1, 3].includes(Number(loading))) this.showHideLoading();
          this.showMessageErrors(error);
        });
    },

    setupTable() {
      const { Table } = configTable();
      this.pagination = { ...Table.pagination };

      try {
        this.tableColumns = Table.tableColumns.concat(
          this.dataByStation.columns
        );
      } catch (error) {
        //
      }
    },
  },

  created() {
    this.setupTable();
    Promise.all([
      Axios.getMasters('devices/stations/only/all'),
      Axios.getMasters('devices/sensors/toSelect/1/name|Eto-Precipitation'),
    ]).then((response) => {
      const [response_stations, response_sensors] = response;
      this.stations = this.concatAll(response_stations.data.data);
      this.sensors = response_sensors.data.data;
      this.showHideLoading();
    });
  },

  mounted() {
    this.selectedItemOnMenu('irrigation');
  },

  destroyed() {
    this.deselectedItemOnMenu('irrigation');
  },
};
</script>
